import React from "react";
import StudentPerformanceTableState, { StudentPerformanceTableProps } from "./StudentPerformanceTable.models";
import './StudentPerformanceTable.scss';
import DatePickerPeriod from "../../shared/date-picker/period/DatePickerPeriod";
import { PeriodDateJson } from "../../../models/dtos/chart/PeriodDateJson";
import StudentService from "../../../services/student/StudentService";
import NotFoundDataInDate from "../../shared/not-found-data-in-date/NotFoundDataInDate";

export default class StudentPerformanceTable extends React.PureComponent<StudentPerformanceTableProps, StudentPerformanceTableState> {

    studentService: StudentService;
    constructor(props: any) {
        super(props);
        this.studentService = new StudentService();
        this.state = { studyPercentageTable: [] };
    }

    componentDidMount() {
    }

    selectPeridDate = (periodDate: PeriodDateJson) => {
        let self = this;
        //#TODO changing to persian date

        if (periodDate !== undefined && periodDate !== null)
            self.getData(periodDate);
    }

    getData(periodDate: PeriodDateJson) {
        let self = this;
        self.studentService.testPercentage({
            fromDate: periodDate.persianCreationFrom,
            toDate: periodDate.persianCreationTo
        }).then(function (response) {
            self.setState({ studyPercentageTable: response });
        });
    }

    render(): React.ReactNode {
        let studyPercentageTable = this.state.studyPercentageTable;
        let content;
        if (studyPercentageTable.length > 0)
            content = (<div className="section student-performance-table-area">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>عنوان</th>
                            <th>میانگین</th>
                            <th>بیشینه</th>
                        </tr>
                    </thead>
                    <tbody>
                        {studyPercentageTable.map((course, key) => {
                            return <tr key={key}>
                                <td>{course.courseTitle}</td>

                                <td className={Number(Number(course.averagePerformance)) >= 90 ? "green"
                                    : Number(course.averagePerformance) >= 60 && Number(course.averagePerformance) <= 90 ? "green-lite"
                                        : Number(course.averagePerformance) >= 40 && Number(course.averagePerformance) <= 60 ? "yellow"
                                            : "red"}>
                                    {course.averagePerformance}
                                </td>

                                <td className={Number(Number(course.maximumPerformance)) >= 90 ? "green"
                                    : Number(course.maximumPerformance) >= 60 && Number(course.maximumPerformance) <= 90 ? "green-lite"
                                        : Number(course.maximumPerformance) >= 40 && Number(course.maximumPerformance) <= 60 ? "yellow"
                                            : "red"}>
                                    {course.maximumPerformance}
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>);
        else {
            content = (<NotFoundDataInDate />);
        }
        return (<>
            <div className="student-performance-table-area mr-lg-5 mb-4">
                <DatePickerPeriod afterSelect={this.selectPeridDate} color="#b9b9b9" />
            </div>
            {content}
        </>)
    }
}


